import { Component, ChangeDetectionStrategy } from '@angular/core';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { CookieConsentComponent } from '@solidgroup-agency/ui-shared-components';

/**
 * Cookie-Banner für Elternportal und Website (#1082).
 *
 * Die Bibliothekskomponente liefert deutsche Standardtexte; übersetzt wird nur,
 * was hier per `$localize` durchgereicht wird. Deshalb werden ALLE Texte gesetzt —
 * ein Text, der hier fehlt, bleibt in der englischen Ansicht deutsch, und ein
 * von Hand ins XLF geschriebener Schlüssel ohne `$localize` wirkt nicht und
 * fliegt beim nächsten `extract` wieder raus.
 */
@Component({
  selector: 'lib-care-cookie-consent-wrapper',
  imports: [
    MatSnackBarModule,
    MatButtonModule,
    MatDialogModule,
    CookieConsentComponent,
  ],
  template: `
    <lib-cookie-consent
      [titleText]="titleText"
      [closeAriaLabel]="closeAriaLabel"
      [mainText]="mainText"
      [necessaryCookiesText]="necessaryCookiesText"
      [necessaryCookiesDescription]="necessaryCookiesDescription"
      [analyticsCookiesText]="analyticsCookiesText"
      [analyticsCookiesDescription]="analyticsCookiesDescription"
      [rejectAllText]="rejectAllText"
      [acceptSelectedText]="acceptSelectedText"
      [acceptAllText]="acceptAllText"
      [cookieSettingsText]="cookieSettingsText"
      [privacyPolicyText]="privacyPolicyText"
    />
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
  styles: [
    `
      lib-cookie-consent {
        --cc-bg: #fff;
      }
    `,
  ],
})
export class CookieConsentComponentWrapper {
  titleText = $localize`:@@cookieConsent.title:Cookie-Einstellungen`;
  closeAriaLabel = $localize`:@@cookieConsent.closeAriaLabel:Cookie-Banner schließen`;
  mainText = $localize`:@@cookieConsent.description:Um unsere Webseite für Sie optimal zu gestalten und fortlaufend verbessern zu können, verwenden wir Cookies. Neben den technisch notwendigen Cookies, die für die Funktion der Webseite unerlässlich sind, nutzen wir Analyse- und Performance-Cookies (Google Analytics, Firebase Performance Monitoring). Sie können selbst entscheiden, welche Cookies Sie zulassen möchten. Weitere Informationen erhalten Sie in unserer Datenschutzerklärung.`;
  necessaryCookiesText = $localize`:@@cookieConsent.necessaryCookies:Notwendige Cookies`;
  necessaryCookiesDescription = $localize`:@@cookieConsent.necessaryCookiesDescription:Diese Cookies sind für den Betrieb der Website erforderlich und können nicht deaktiviert werden.`;
  analyticsCookiesText = $localize`:@@cookieConsent.analyticsCookies:Analyse-Cookies`;
  analyticsCookiesDescription = $localize`:@@cookieConsent.analyticsCookiesDescription:Diese Cookies ermöglichen es uns, die Nutzung der Website zu analysieren und unsere Dienste zu verbessern.`;
  rejectAllText = $localize`:@@cookieConsent.rejectAll:Alles ablehnen`;
  acceptSelectedText = $localize`:@@cookieConsent.acceptSelected:Auswahl akzeptieren`;
  acceptAllText = $localize`:@@cookieConsent.acceptAllCookies:Alle Cookies akzeptieren`;
  cookieSettingsText = $localize`:@@cookieConsent.cookieSettings:Mehr erfahren`;
  privacyPolicyText = $localize`:@@cookieConsent.privacyPolicy:Datenschutzerklärung`;
}
